import { ToolName } from "../types";

export const isComputerAgentToolName = (name: string | undefined) =>
  name?.toLowerCase() === ToolName.COMPUTER_AGENT;

export const isCreateAnalyticsGraphToolName = (name: string | undefined) =>
  name?.toLowerCase() === ToolName.CREATE_ANALYTICS_GRAPH;
